const Constants = {
  WS_BRAND_CONNECTIONS: {
    zillow: 'wss://www.zillow.com/rental-manager-api/ws/services',
    hotpads: 'wss://hotpads.com/rental-manager-api/ws/services',
    trulia: 'wss://www.trulia.com/rental-manager-api/ws/services',
    TEST: 'ws://localhost:8080',
  },
};

export default Constants;
